import { v4 as uuid } from "uuid";
import { useContext, useEffect, useState } from "react";
import { CountriesContext } from "../contexts/countriescontexts";
import axios from "axios";
export default function Searchh({countrysearch,setcountrysearch}) {
  const [country, setcountry] = useState([]);
  const [cou, setcou] = useState([]);
  const variable = useContext(CountriesContext);

    useEffect(() => {if(countrysearch){
    axios
      .get(`https://restcountries.com/v3.1/name/${variable.s}`)
      .then(function (response) {
        console.log(response);
        setcountry([response.data[0]]);
        console.log(country, "ll");
      });
    console.log(country, "search");
  }}, [variable.s]);
  useEffect(() => {
    setcou([
      country.map((i) => {
        return (
          <div
            key={uuid()}
            style={{ display: "flex", flexDirection: "column", gap: "15%" }}
          >
            <div style={{ background: "green" }}>
              <h1>{i.translations.ara.official}</h1>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
                background: "red",
                marginTop: "10px",
              }}
            >
              <h2> {i.capital[0]} : العاصمة </h2>

              <h2>{i.population} : عدد السكان </h2>
              <h2 >{i.area }km    <sup>2</sup>    :  المساحة</h2>
              <h2>{i.idd.root + i.idd.suffixes} رمز الاتصال الدولي </h2>

            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
                background: "yellow",
                marginTop: "10px",
              }}
            >
              <h2>{i.borders.join(" | ")} : الحدود </h2>

              <h2>{i.continents} : القارة </h2>

              <h2>
                {(i.languages && Object.values(i.languages)?.[0]) ||
                  "جار التحميل"}{" "}
                : اللغة الرسمية{" "}
              </h2>

              <h2>{i.latlng.join(" | ")} : خطوط الطول والعرض </h2>
            </div>

            <div
              style={{
                width: "100%",
                height: "10%",
                display: "flex",
                justifyContent: "space-around",
                marginTop: "10px",
              }}
            >
              <img
                src={i.coatOfArms.png}
                style={{ width: "30%", height: "50%" }}
              ></img>{" "}
              <h2>: الشعار</h2>
              <img src={i.flags.png}></img> <h2> : العلم </h2>
            </div>
          </div>
        );
      }),
    ]);
  }, [country, variable.s]);


  return (
    <div
      style={{
        transition: "all .9s ease-in-out ",
        width: "100%",
        height: "95%",
        overflowX: "hidden",
        overflowY: "scroll",
        flexDirection: "column",
        alignItems: "center",
        display: "flex",
        padding: "20px ",
        scrollbarWidth: "auto",
        background: "purple",
        color: "whtie",
      }}
    >
      <div
        style={{
          transition: "all .9s ease-in-out ",
          width: "100%",
          height: "95%",
        }}
      >
        {cou}
      </div>
    </div>
  );
}
